<!-- gap-1.5 overrides the card's default --card-spacing gap: label and figure
     belong together as one unit, the card padding does the outer spacing. -->
<div hlmCard data-size="sm" class="h-full gap-1.5">
  <div hlmCardHeader>
    <p hlmCardDescription class="truncate">{{ label }}</p>
    @if (iconTemplate) {
      <span hlmCardAction class="text-muted-foreground">
        <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
      </span>
    }
  </div>
  <!-- Additive bindings, not [class]: hlmCardContent manages this element's
       class list itself, and a whole-list binding fights it. -->
  <div hlmCardContent class="mt-auto" [class.text-end]="align === 'end'">
    <p class="truncate text-2xl font-semibold tabular-nums" [class]="valueClass" [title]="value">
      {{ value }}
    </p>
    @if (subtext) {
      <p hlmCardDescription class="mt-0.5 text-xs">{{ subtext }}</p>
    }
  </div>
</div>
